import React, { useEffect } from "react";
import { useAuth } from "hooks/auth/useAuth";
import { useNavigate } from "react-router-dom";

interface AuthRouteProps {
  children: React.ReactNode;
}

const AuthRoute = ({ children }: AuthRouteProps) => {
  const { currentUser, role, isLoading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const handleRedirect = () => {
      navigate(`/${role}`);
    };
    if (currentUser && role) {
      handleRedirect();
    }
  }, [currentUser, navigate, role, isLoading]);

  return <>{children}</>;
};

export default AuthRoute;
